import clsx from "clsx";
import React, { useEffect, useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import styles from "./omnibus-directive-banner.module.css";

function OmnibusDirectiveBannerCopy(): JSX.Element {
    const omnibusLinkProps = ` href=${environment.get(
        "urlPatterns.helpProductRanking"
    )} target="_blank"`;
    return (
        <span
            className={styles.copy}
            dangerouslySetInnerHTML={{
                __html: gettext("feed.omnibus_disclaimer.label", {
                    omnibus_link_props: omnibusLinkProps,
                }),
            }}
            onClick={() => analytics.event("omnibus_banner", "cta_click")}
        />
    );
}

export function OmnibusDirectiveBanner(): JSX.Element | null {
    const [isClosed, setIsClosed] = useState(true);

    function handleClick(): void {
        analytics.event("omnibus_banner", "close");
        userProfiler.setOmnibusIsClosed(true);
        setIsClosed(!isClosed);
    }

    useEffect(() => {
        setIsClosed(userProfiler.hasOmnibusBeenClosed());
    }, []);

    if (isClosed) {
        return null;
    }

    return (
        <div className={styles.container}>
            <SVGIcon name={"info-icon"} className={styles.icons}></SVGIcon>
            <OmnibusDirectiveBannerCopy />
            <button onClick={handleClick} className={clsx(styles.icons, styles.closeIcon)}>
                <SVGIcon name={"close"}></SVGIcon>
            </button>
        </div>
    );
}
